import { defineChapter } from '../../define';
import boss from './challenges/boss/meta';
import defaultBug from './challenges/default-bug/meta';
import exportsPredict from './challenges/exports-predict/meta';
import modulePattern from './challenges/module-pattern/meta';

export default defineChapter({
  id: 'js-modules',
  slug: 'modules',
  title: 'Modules and tooling',
  position: 6,
  challenges: [exportsPredict, defaultBug, modulePattern, boss],
});
